import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=cbb27ed2&scoped=true"
import script from "./QuestionText.vue?vue&type=script&lang=js"
export * from "./QuestionText.vue?vue&type=script&lang=js"
import style0 from "./QuestionText.vue?vue&type=style&index=0&id=cbb27ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb27ed2",
  null
  
)

export default component.exports